import { FC, useEffect, useState } from 'react';
import './DataBreach.scss';
import { BarChart } from './BarChart/BarChart';
import { BarChartEntry, BarRanges } from './BarChart/BarChart.types';
import { MOBILE_MOCKUP_WIDTH } from '../constants';
import { Layout, Mode } from '../enums';
import Accordion from './Accordion/Accordion';
import { FormattedMessage } from 'react-intl';
import messages from '../locales/messages';

const DATA: BarChartEntry[] = [
  {
    label: 'dataPoint1',
    primaryValue: 4910000,
    secondaryValue: 16,
  },
  {
    label: 'dataPoint2',
    primaryValue: 4890000,
    secondaryValue: 6,
  },
  {
    label: 'dataPoint3',
    primaryValue: 4550000,
    secondaryValue: 13,
  },
  {
    label: 'dataPoint4',
    primaryValue: 4500000,
    secondaryValue: 19,
  },
  {
    label: 'dataPoint5',
    primaryValue: 4180000,
    secondaryValue: 8,
  },
  {
    label: 'dataPoint6',
    primaryValue: 4140000,
    secondaryValue: 15,
  },
  {
    label: 'dataPoint7',
    primaryValue: 4100000,
    secondaryValue: 3,
  },
  {
    label: 'dataPoint8',
    primaryValue: 3960000,
    secondaryValue: 9,
  },
  {
    label: 'dataPoint9',
    primaryValue: 3940000,
    secondaryValue: 5,
  },
  {
    label: 'dataPoint10',
    primaryValue: 3820000,
    secondaryValue: 7,
  },
];

const RANGES: BarRanges = {
  primary: {
    min: 0,
    max: 5000000,
    step: 1000000,
  },
  secondary: {
    min: 0,
    max: 50,
    step: 10,
  },
};

const DataBreachBars: FC = () => {
  const [size, setSize] = useState<Layout | null>(null);
  const [mode, setMode] = useState<Mode>(Mode.Cost);
  const [parent, setParent] = useState<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number>(NaN);
  const entries = DATA.sort((a, b) => {
    const prop = mode === Mode.Cost ? 'primaryValue' : 'secondaryValue';
    return a[prop] < b[prop] ? 1 : -1;
  });
  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      setSize(
        entry.target.clientWidth > MOBILE_MOCKUP_WIDTH
          ? Layout.Desktop
          : Layout.Mobile,
      );
    });
    observer.observe(document.body);
    return () => {
      observer.unobserve(document.body);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!parent) return;
    const observer = new ResizeObserver(([entry]) => {
      setHeight(entry.target.clientHeight);
    });
    observer.observe(parent);
    return () => {
      observer.unobserve(parent);
      observer.disconnect();
    };
  }, [parent]);

  return (
    <div className="data-breach__wrapper" ref={setParent}>
      {size && (
        <BarChart
          isMobile={size === Layout.Mobile}
          isPrimary={mode === Mode.Cost}
          entries={entries}
          ranges={RANGES}
          scalePattern={{
            primary: (v) => `$${v / 1000000}M`,
            secondary: (v) => `${v}%`,
          }}
          valuePattern={{
            primary: (v) => `$${(v / 1000000).toFixed(2)}`,
            secondary: (v) => `${v.toFixed(0)}%`,
          }}
        />
      )}
      <div className="data-breach__footer">
        <div className="data-breach__info">
          <FormattedMessage {...messages.asteriskMessage} />
        </div>
        <Accordion widgetHeight={height} mode={mode} setMode={setMode} />
      </div>
    </div>
  );
};

export default DataBreachBars;
